module.exports = __webpack_public_path__ + "static/media/down-arrow.2f35bb31.svg";